import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
class GLApp {
    constructor() {


        window.app = this
        this.$body = document.querySelector('body')
        /*----------------------------------------------*/
        //   Renderer                                   */
        /*----------------------------------------------*/
        this.canvas = document.querySelector('canvas#sketch');
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)
        this.renderer = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            alpha: true
        });
        this.renderer.setClearColor(0x000000, 0)
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setPixelRatio(this.pixelRatio)


        /*----------------------------------------------*/
        //   Scene & Camera                             */
        /*----------------------------------------------*/
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 100);
        this.camera.position.z = 5.5;
        this.group = new THREE.Group();
        this.scene.add(this.group);



        /*----------------------------------------------*/
        //   OrbitControl                              */
        /*----------------------------------------------*/
        this.controls = new OrbitControls(this.camera, this.canvas)
        this.controls.enableDamping = true


        /*----------------------------------------------*/
        //   Resize                                     */
        /*----------------------------------------------*/
        function onResize() {
            that.camera.aspect = window.innerWidth / window.innerHeight;
            that.camera.updateProjectionMatrix();

            that.pixelRatio = Math.min(window.devicePixelRatio, 2)
            that.renderer.setSize(window.innerWidth, window.innerHeight);
            that.renderer.setPixelRatio(that.pixelRatio)
        }
        window.addEventListener('resize', onResize, false);

        /*----------------------------------------------*/
        //   Models                                     */
        /*----------------------------------------------*/
        this.sphere = this.initSphere(this)

        /*----------------------------------------------*/
        //   Loop                                       */
        /*----------------------------------------------*/
        let that = this
        function animate() {
            requestAnimationFrame(animate)
            if (that.is_ready) {
                that.update()
            }
            that.renderer.render(that.scene, that.camera)

            that.controls.update()
        }
        animate()

    }

    initSphere(gl_app) {
        this.is_ready = false
        this.textureLoader = new THREE.TextureLoader();
        this.totalItems = 100;
        this.baseWidth = 1;
        this.baseHeight = 1.3;
        this.sphereRadius = 6;
        this.loadedCount = 0;

        // Remote asset lists (external sources)
        this.remoteVideos = [
            // 'https://cdn.shopify.com/videos/c/o/v/48fdf51e13984f5dadbc22314a923291.mp4',
            'https://cdn.shopify.com/videos/c/o/v/b2d23ab65f15429cb968928af15a20c5.mp4',
            'https://cdn.shopify.com/videos/c/o/v/a9d9689269f447a8a7b3b25556e911f4.mp4',
            'https://cdn.shopify.com/videos/c/o/v/c3ccbb55659e4bc3b28c51b58f52f279.mp4',
            'https://cdn.shopify.com/videos/c/o/v/b0913d494c534399bf629253597975bd.mp4',
            'https://cdn.shopify.com/videos/c/o/v/4350d0ce5a214feaba25202d8631795f.mp4',
            'https://cdn.shopify.com/videos/c/o/v/9c4c4c0e7719410b8bad4c7297f3a09f.mp4',
            'https://cdn.shopify.com/videos/c/o/v/d2593a2941234b37a38a0450bad8ddb7.mp4',
            'https://cdn.shopify.com/videos/c/o/v/eb721560cb15406d98a61b860d16fbc8.mp4',
            'https://cdn.shopify.com/videos/c/o/v/40ea61f041254d1b8f4264968adc3c92.mp4',
            'https://cdn.shopify.com/videos/c/o/v/46cc9756b84743549d7537ca1ae1ac2a.mp4',
            'https://cdn.shopify.com/videos/c/o/v/e000754858f243af9519d85916a9a1ec.mp4'
        ];
        this.remoteImages = [
            'https://cdn.shopify.com/s/files/1/0724/3025/6436/files/logo_dark.png',
            'https://cdn.shopify.com/s/files/1/0724/3025/6436/files/logo_grain.png',
            'https://cdn.shopify.com/s/files/1/0724/3025/6436/files/logo_soft.png'
        ];

        // Preloader properties (derived from remote lists)
        this.loadedAssets = {
            videos: [],
            images: []
        }
        this.totalAssets = 0
        this.assetLoadedCount = 0
        this.videoTextures = []
        this.imageTextures = []
        this.raycaster = new THREE.Raycaster()
        this.mouse = new THREE.Vector2()
        this.lastRepulseTime = 0

        // Material params for debugging
        this.params = {
            useAllAssets: true,
            borderRadius: 0.05,
            repulseDistance: 1.2,
            repulseDuration: 1,
            repulseReturnDelay: 0,
            maxIntersections: 2,
        }

        this.preloadAssets()

    }

    async preloadAssets() {
        try {
            const videoFiles = this.remoteVideos;
            const imageFiles = this.remoteImages;

            this.totalAssets = videoFiles.length + imageFiles.length;

            if (this.totalAssets === 0) {
                this.createSphere();
                return;
            }


            const videoPromises = videoFiles.map(v => this.loadVideo(v));
            const imagePromises = imageFiles.map(i => this.loadImage(i));
            await Promise.all([...videoPromises, ...imagePromises]);

            this.createTexturesFromAssets();
            this.createSphere();

            if (this.params.useAllAssets) {
                this.loadedAssets.videos.forEach(video => video.play());
            }

        } catch (error) {
            this.createSphere();
        }
    }


    loadVideo(videoPath) {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            video.preload = 'auto';
            video.loop = true;
            video.muted = true; // allow autoplay
            video.playsInline = true;
            video.autoplay = true;
            video.crossOrigin = 'anonymous';

            const finalize = () => {
                // Ensure playback started
                const playPromise = video.play();
                if (playPromise && playPromise.catch) {
                    playPromise.catch(() => {/* ignore autoplay rejection */ });
                }
                this.loadedAssets.videos.push(video);
                this.onAssetLoaded();
                resolve(video);
            };

            video.onloadeddata = finalize;
            video.onloadedmetadata = finalize;
            video.oncanplay = () => {
                if (video.readyState >= 2 && !video.paused) return;
                finalize();
            };

            video.onerror = () => {
                this.onAssetLoaded();
                reject(new Error(`Failed to load video: ${videoPath}`));
            };

            video.src = videoPath;
        });
    }

    loadImage(imagePath) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            // Set crossOrigin BEFORE src so remote headers can be evaluated
            img.crossOrigin = 'anonymous';

            img.onload = () => {
                this.loadedAssets.images.push(img);
                this.onAssetLoaded();
                resolve(img);
            };

            img.onerror = () => {
                this.onAssetLoaded();
                reject(new Error(`Failed to load image: ${imagePath}`));
            };

            img.src = imagePath;
        });
    }

    onAssetLoaded() {
        this.assetLoadedCount++;
        const progress = (this.assetLoadedCount / this.totalAssets) * 100;
    }

    createTexturesFromAssets() {
        // Create video textures
        this.videoTextures = this.loadedAssets.videos.map(video => {
            const texture = new THREE.VideoTexture(video);
            texture.minFilter = THREE.LinearFilter;
            texture.magFilter = THREE.LinearFilter;
            texture.format = THREE.RGBAFormat;
            texture.colorSpace = THREE.SRGBColorSpace;
            texture.needsUpdate = true;
            return texture;
        });

        // Create image textures
        this.imageTextures = this.loadedAssets.images.map(img => {
            const texture = new THREE.Texture(img);
            texture.needsUpdate = true;
            texture.wrapS = THREE.RepeatWrapping;
            texture.wrapT = THREE.RepeatWrapping;
            texture.colorSpace = THREE.SRGBColorSpace;
            texture.generateMipmaps = false;
            texture.minFilter = THREE.LinearFilter;
            texture.magFilter = THREE.LinearFilter;
            return texture;
        });

    }


    getRandomTexture() {
        const allTextures = [...this.videoTextures, ...this.imageTextures];
        if (allTextures.length === 0) return null;
        const index = this.loadedCount % allTextures.length;
        return allTextures[index];
    }

    createImagePlane(texture) {
        const imageAspect = texture.image.width / texture.image.height;
        let width = this.baseWidth;
        let height = this.baseHeight;

        if (imageAspect > 1) {
            height = width / imageAspect;
        } else {
            width = height * imageAspect;
        }

        return new THREE.PlaneGeometry(width, height);
    };


    loadImageMesh(phi, theta) {
        const texture = this.getRandomTexture();
        if (!texture) return;
    };

    rotateGroups() {
        gsap.to(this.group.rotation, { repeat: -1, duration: 60, ease: 'linear', y: - Math.PI * 2, });
    }




    createSphere() {
        // Prepare positions first
        this.instanceGroups = [];
        const allTextures = [...this.videoTextures, ...this.imageTextures];
        if (!allTextures.length) {
            // Fallback: no assets, skip instancing
            return;
        }
        // Build groups map textureIndex -> data
        const groupsData = allTextures.map((tex) => ({
            texture: tex,
            isVideo: this.videoTextures.includes(tex),
            positions: [], // base positions
            current: [],   // animated positions
        }));

        const goldenAngle = Math.PI * (3 - Math.sqrt(5));
        for (let i = 0; i < this.totalItems; i++) {
            const y = 1 - (i / (this.totalItems - 1)) * 2;
            const radius = Math.sqrt(1 - y * y);
            const theta = goldenAngle * i;
            const x = Math.cos(theta) * radius;
            const z = Math.sin(theta) * radius;
            // Convert to spherical for consistency with original approach
            const phi = Math.acos(y);
            const theta_sph = Math.atan2(z, x);

            const pos = new THREE.Vector3(
                this.sphereRadius * Math.cos(theta_sph) * Math.sin(phi),
                this.sphereRadius * Math.sin(theta_sph) * Math.sin(phi),
                this.sphereRadius * Math.cos(phi)
            );
            // Assign texture round-robin
            const texIndex = i % allTextures.length;
            groupsData[texIndex].positions.push(pos);
            groupsData[texIndex].current.push(pos.clone());
        }

        // Create instanced meshes per texture
        groupsData.forEach((data) => {
            const tex = data.texture;
            tex.colorSpace = THREE.SRGBColorSpace;
            tex.generateMipmaps = false;
            tex.minFilter = THREE.LinearFilter;
            tex.magFilter = THREE.LinearFilter;

            // Geometry sized by aspect ratio of its texture
            let geometry;
            if (data.isVideo && tex.source && tex.source.data && tex.source.data.videoWidth) {
                const vw = tex.source.data.videoWidth;
                const vh = tex.source.data.videoHeight || vw;
                const aspect = vw / vh;
                let w = this.baseWidth;
                let h = this.baseHeight;
                if (aspect > 1) h = w / aspect; else w = h * aspect;
                geometry = new THREE.PlaneGeometry(w, h);
            } else if (tex.image && tex.image.width) {
                geometry = this.createImagePlane(tex);
            } else {
                geometry = new THREE.PlaneGeometry(this.baseWidth, this.baseHeight);
            }

            let material;
            if (data.isVideo) {
                material = new THREE.ShaderMaterial({
                    uniforms: {
                        uMap: { value: tex },
                        uBorderRadius: { value: this.params.borderRadius },
                    },
                    vertexShader: /* glsl */`
                        // Do NOT redeclare instanceMatrix; InstancedMesh injects it automatically.
                        varying vec2 vUv;
                        void main(){
                            vUv = uv;
                            #ifdef USE_INSTANCING
                                gl_Position = projectionMatrix * modelViewMatrix * instanceMatrix * vec4(position,1.0);
                            #else
                                gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
                            #endif
                        }
                    `,
                    fragmentShader: /* glsl */`
                        precision mediump float;
                        varying vec2 vUv;
                        uniform sampler2D uMap;
                        uniform float uBorderRadius;
                        float roundedRectSDF(vec2 uv, float radius){
                            vec2 p = uv - 0.5;
                            float r = radius;
                            vec2 a = 0.5 - vec2(r);
                            vec2 q = abs(p) - a;
                            return length(max(q,0.0)) - r;
                        }
                        void main(){
                            float r = clamp(uBorderRadius, 0.0, 0.5);
                            float d = roundedRectSDF(vUv, r);
                            vec4 texel = texture2D(uMap, vUv);
                            float aa = fwidth(d);
                            float alphaMask = 1.0 - smoothstep(0.0, aa, d);
                            if(alphaMask <= 0.0){ discard; }
                            gl_FragColor = vec4(texel.rgb, texel.a * alphaMask);
                        }
                    `,
                    transparent: true,
                    side: THREE.DoubleSide,
                    depthWrite: true,
                    depthTest: true,
                });
            } else {
                material = new THREE.MeshBasicMaterial({
                    map: tex,
                    transparent: true,
                    side: THREE.DoubleSide,
                    depthWrite: true,
                    depthTest: true,
                });
            }

            const count = data.positions.length;
            const instanced = new THREE.InstancedMesh(geometry, material, count);
            instanced.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
            const dummy = new THREE.Object3D();
            for (let i = 0; i < count; i++) {
                dummy.position.copy(data.positions[i]);
                dummy.lookAt(0, 0, 0);
                dummy.updateMatrix();
                instanced.setMatrixAt(i, dummy.matrix);
            }
            instanced.userData.groupData = data; // attach group data
            this.group.add(instanced);
            this.instanceGroups.push({ mesh: instanced, data });
        });

        if(window.innerWidth < 569) {
            this.group.scale.setScalar(0.3);
            this.group.position.x = -0.15;
        }
        //desktop
        else {
            this.group.scale.setScalar(0.45);
            this.is_ready = true;
        }
        document.querySelector('.bg-hero__decor__img').style.opacity = 0;
        this.rotateGroups();
        window.addEventListener('mousemove', (e) => this.onPointerMove(e), { passive: true });
    };


    onPointerMove(e) {
        if (!this.is_ready || !this.$body.classList.contains('is-hero')) return;
        const now = performance.now();
        // throttle to avoid excessive gsap allocations
        if (now - this.lastRepulseTime < 80) return;
        this.lastRepulseTime = now;
        const rect = this.renderer.domElement.getBoundingClientRect();
        this.mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
        this.mouse.y = - ((e.clientY - rect.top) / rect.height) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
        const intersects = this.raycaster.intersectObjects(this.group.children, false);
        if (!intersects.length) return;
        let handled = 0;
        const dummy = new THREE.Object3D();
        for (const inter of intersects) {
            if (handled >= this.params.maxIntersections) break;
            const instanced = inter.object;
            const instanceId = inter.instanceId;
            if (instanceId === undefined) continue; // skip non-instanced
            const data = instanced.userData.groupData;
            const basePos = data.positions[instanceId];
            if (!basePos) continue;
            const currentPos = data.current[instanceId];
            // Kill existing tween attached via symbol key
            const tweenKey = `_tween_${instanceId}`;
            if (instanced.userData[tweenKey]) {
                instanced.userData[tweenKey].kill();
            }
            const dir = currentPos.clone().normalize();
            const target = basePos.clone().add(dir.multiplyScalar(this.params.repulseDistance));
            const animObj = { x: currentPos.x, y: currentPos.y, z: currentPos.z };
            const tween = gsap.to(animObj, {
                x: target.x,
                y: target.y,
                z: target.z,
                duration: this.params.repulseDuration,
                ease: 'power3.out',
                onUpdate: () => {
                    currentPos.set(animObj.x, animObj.y, animObj.z);
                    dummy.position.copy(currentPos);
                    dummy.lookAt(0, 0, 0);
                    dummy.updateMatrix();
                    instanced.setMatrixAt(instanceId, dummy.matrix);
                    instanced.instanceMatrix.needsUpdate = true;
                },
                onComplete: () => {
                    gsap.to(animObj, {
                        x: basePos.x,
                        y: basePos.y,
                        z: basePos.z,
                        duration: this.params.repulseDuration * 0.2,
                        ease: 'power3.out',
                        delay: this.params.repulseReturnDelay,
                        onUpdate: () => {
                            currentPos.set(animObj.x, animObj.y, animObj.z);
                            dummy.position.copy(currentPos);
                            dummy.lookAt(0, 0, 0);
                            dummy.updateMatrix();
                            instanced.setMatrixAt(instanceId, dummy.matrix);
                            instanced.instanceMatrix.needsUpdate = true;
                        }
                    });
                }
            });
            instanced.userData[tweenKey] = tween;
            handled++;
        }
    }


    //? - =========================  UPDATES  ========================= -//
    //? - =========================  UPDATES  ========================= -//
    update() {
        if (this.is_ready && this.$body.classList.contains('is-hero')) {
            for (const vt of this.videoTextures) {
                vt.needsUpdate = true;
            }
        }
    }
}


new GLApp();

